'use client';

import { useState } from 'react';
import { Check } from 'lucide-react';

const INITIAL_TASKS = [
  { id: 't1', title: 'Pick up Metformin refill', due: 'Due today', assignee: 'Michael', done: false },
  { id: 't2', title: 'Schedule follow-up with Dr. Chen', due: 'Due Feb 17', assignee: null, done: false },
  { id: 't3', title: 'Review insurance documents', due: 'Due Feb 20', assignee: null, done: false },
];

export default function UpcomingTasksList() {
  const [tasks, setTasks] = useState(INITIAL_TASKS);

  const toggle = (id: string) => {
    setTasks((prev) =>
      prev.map((t) => (t.id === id ? { ...t, done: !t.done } : t))
    );
  };

  return (
    <div className="glass overflow-hidden">
      <div className="px-4 py-3 border-b border-[#E0DBD3] bg-[#F5F1EB]/50">
        <h3
          className="text-sm font-semibold text-[#312F2F]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Upcoming Tasks
        </h3>
      </div>
      <ul className="divide-y divide-[#E0DBD3]/80">
        {tasks.map((task) => (
          <li key={task.id} className="group">
            <label className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-[#F5F1EB]/40 transition-colors">
              <span className="flex-shrink-0 pt-0.5">
                <input
                  type="checkbox"
                  checked={task.done}
                  onChange={() => toggle(task.id)}
                  className="sr-only peer"
                />
                <span
                  className={`flex w-5 h-5 items-center justify-center rounded-md border-2 transition-all duration-200 ${
                    task.done
                      ? 'bg-[#D6AB47] border-[#D6AB47]'
                      : 'border-[#E0DBD3] group-hover:border-[#D6AB47]/50'
                  }`}
                >
                  {task.done && <Check size={12} strokeWidth={3} className="text-[#000000]" />}
                </span>
              </span>
              <div className="min-w-0 flex-1">
                <span
                  className={`text-sm font-medium block ${
                    task.done ? 'line-through text-[#9B9590]' : 'text-[#312F2F]'
                  }`}
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {task.title}
                </span>
                <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                  <span
                    className="text-xs text-[#9B9590]"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {task.due}
                  </span>
                  {task.assignee && (
                    <>
                      <span className="text-[#9B9590]">·</span>
                      <span
                        className="text-xs text-[#9B9590]"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        {task.assignee}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
